import { Grid, IconButton, Tooltip } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import DataTable from "custom/Tables/DataTable";
import MessageTypes from "enums/message-types";
import { FunnelSimple, Pencil } from "phosphor-react";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { removeMessage } from "redux/actions/message";
import {
  ALL_SUB_ORGANIZATIONS,
  startAllSubOrganizationsScreen,
  getSubOrganizationListByOrganizationId,
} from "redux/actions/pages/sub-organization";

import { startAllOrganizationsScreen } from "redux/actions/pages/organization";

import Swal from "sweetalert2";
import SuiTypography from "components/SuiTypography";
import CustomFormField from "components/CustomFormField";
import { Formik } from "formik";

const SubOrganizationList = ({
  message,
  localizations,
  allSubOrganizations,
  startScreen,
  removeErrorMsg,
  language,
  allOrganizations,
  listByOrganizationId,
  getAllOrganizations,
}) => {
  const [subOrganizationFilter, setSubOrganizationFilter] = useState("");
  const history = useHistory();

  useEffect(() => {
    startScreen();
    if (!allOrganizations || allOrganizations.length === 0) {
      getAllOrganizations();
    }
  }, []);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ""
    ) {
      Swal.fire({
        icon: message.messageType || "error",
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS ?? "BAŞARILI!"
            : localizations?.MESSAGE_ERROR ?? "HATA!",
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_GO_HOME_CONFIRM_BTN,
      }).then((result) => {
        removeErrorMsg(ALL_SUB_ORGANIZATIONS);
        if (result.isConfirmed) {
          history.push("/");
        }
      });
    }
    // eslint-disable-next-line
  }, [message]);

  const columns = [
    { Header: localizations?.SUB_ORGANIZATION ?? "SUBORGANIZATION", accessor: "subOrganization" },
    {
      Header: localizations?.ACTIONS ?? "Actions",
      accessor: "preview",
      // eslint-disable-next-line react/prop-types
      Cell: ({ value: [data] }) => (
        <SuiBox mx={1} display="flex">
          <Tooltip title={localizations?.EDIT ?? "Düzenle"} placement="bottom">
            <IconButton
              aria-label={localizations?.EDIT}
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: "/suborganization/edit",
                  state: { subOrganizationId: data.id, organizationId: data.organizationId },
                });
              }}
            >
              <Pencil size={32} weight="duotone" color="#7493b6" />
            </IconButton>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const getDataTableData = (subOrganizationList, filter, lang) => ({
    columns,
    rows:
      subOrganizationList && subOrganizationList.length > 0
        ? subOrganizationList
            .filter((so) => {
              let lowercaseFilter = "";
              if (filter && filter !== "") {
                lowercaseFilter = filter.toLocaleLowerCase(lang);
              }
              return so.subOrganizationKey.toLocaleLowerCase(lang).includes(lowercaseFilter);
            })
            .map((so) => ({
              subOrganization: so.subOrganizationKey,
              preview: [{ id: so.id, organizationId: so.organizationId }],
            }))
        : [],
  });

  const memoizedTableData = useMemo(
    () => getDataTableData(allSubOrganizations, subOrganizationFilter, language),
    [subOrganizationFilter, allSubOrganizations, language]
  );
  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          <Grid container>
            <Grid item sm={7} xs={12}>
              <h3>{localizations?.SUB_ORGANIZATIONS ?? "Şube Listesi"}</h3>
            </Grid>
            <Grid item sm={5} xs={12} sx={{ textAlign: "right" }}>
              <SuiInput
                size="small"
                type="search"
                placeholder={
                  localizations?.SUB_ORGANIZATION_FILTER_INPUT_PLACEHOLDER ??
                  "Sub-Organization Ara..."
                }
                icon={{ component: <FunnelSimple />, direction: "left" }}
                value={subOrganizationFilter}
                onChange={(e) => setSubOrganizationFilter(e.target.value)}
              />
            </Grid>
            <Grid item lg={12} xs={12} mt={3}>
              <SuiTypography variant="h6" fontWeight="medium">
                {localizations?.SUB_ORGANIZATIONS ?? "Şube Listesi"}
              </SuiTypography>

              <Formik
                initialValues={{
                  organization: null,
                }}
                onSubmit={() => {}}
              >
                {(formikProps) => {
                  const { setFieldValue, values, errors, touched, setFieldTouched } = formikProps;
                  return (
                    <CustomFormField
                      options={
                        allOrganizations &&
                        allOrganizations?.map((organization) => ({
                          value: organization.id,
                          label: organization.organizationKey,
                        }))
                      }
                      type="select"
                      placeholder="Organizasyon seçiniz..."
                      value={values.organization}
                      setFieldValue={(field, value) => {
                        setFieldValue(field, value);
                        if (value && value.value) {
                          listByOrganizationId({ organizationId: value.value });
                        }
                      }}
                      label={localizations?.ORGANIZATION ?? "ORGANIZATION"}
                      name="organization"
                      touched={touched}
                      errors={errors}
                      error={false}
                      success={false}
                      setFieldTouched={setFieldTouched}
                    />
                  );
                }}
              </Formik>
            </Grid>
            <Grid item lg={12} xs={12} mt={3}>
              <DataTable
                table={memoizedTableData}
                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 25, 50] }}
                pagination={{ variant: "contained", color: "dark" }}
              />
            </Grid>
          </Grid>
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

SubOrganizationList.defaultProps = {
  allSubOrganizations: [],
  message: null,
  localizations: null,
  language: "TR",
  listByOrganizationId: () => {},
  allOrganizations: [],
  getAllOrganizations: () => {},
};

SubOrganizationList.propTypes = {
  allSubOrganizations: PropTypes.arrayOf(PropTypes.any),
  message: PropTypes.objectOf(PropTypes.any),
  localizations: PropTypes.objectOf(PropTypes.any),
  startScreen: PropTypes.func.isRequired,
  removeErrorMsg: PropTypes.func.isRequired,
  language: PropTypes.string,
  listByOrganizationId: PropTypes.func,
  allOrganizations: PropTypes.arrayOf(PropTypes.any),
  getAllOrganizations: PropTypes.func,
};

const mapStateToProps = (state) => {
  const subOrganizations = Array.isArray(state?.data?.subOrganizations)
    ? state.data.subOrganizations
    : [];

  const organizations = Array.isArray(state?.data?.organizations) ? state.data.organizations : [];
  return {
    allSubOrganizations: subOrganizations,
    allOrganizations: organizations,
    message: state.message[ALL_SUB_ORGANIZATIONS],
    localizations: state.localization.pairs,
    language: state.localization.language ?? "TR",
  };
};

const mapDispatchToProps = {
  startScreen: startAllSubOrganizationsScreen,
  removeErrorMsg: removeMessage,
  listByOrganizationId: getSubOrganizationListByOrganizationId,
  getAllOrganizations: startAllOrganizationsScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubOrganizationList);
